module.exports = __webpack_public_path__ + "img/Bayern-Munchen.ae67d2c5.png";